export const API_URL = 'https://api.hornygirls.fun';

export const GIRLS_DATA = {
  mia: {
    name: 'Mia',
    bio: 'Aspiring actress with a bubbly personality',
    imageUrl:
      'https://pbs.twimg.com/profile_images/1867301246757199872/vWwDbHVw_400x400.jpg',
  },
  emma: {
    name: 'Emma',
    bio: 'Travel blogger with wanderlust',
    imageUrl: '/girls/2.webp',
  },
  sophia: {
    name: 'Sophia',
    bio: 'Yoga instructor & wellness enthusiast',
    imageUrl: '/girls/1.webp',
  },
  lily: {
    name: 'Lily',
    bio: 'Bookworm & coffee addict',
    imageUrl: '/girls/5.webp',
  },
  luna: {
    name: 'Luna',
    bio: 'Artist & free spirit',
    imageUrl: '/girls/3.webp',
  },
};

export const COSTS = {
  CALL: 30,
  PHOTO: 10,
  VIDEO: 120,
  TOKEN_PACKAGE: {
    AMOUNT: 100,
    COST: 0.1, // в SOL
  },
};
